module.exports = __webpack_public_path__ + "static/media/volume-up.3012b433.svg";